<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                  Ssam 콘텐츠 상세
                </div>
                <div class="list-content">
                    <board-detail-component :boardType="`ssamsContentDetail`"  :boardKey="boardKey"
                                            :ssamsKey="ssamsKey"></board-detail-component>
                    <comment-list-component :boardType="'ssamsContentCommentList'" :boardKey="boardKey"
                                            :ssamsKey="ssamsKey"></comment-list-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
        <comment-reply-modal :commentType="'userCommentReplyList'"></comment-reply-modal>
    </div>
</template>

<script>
    import BoardDetailComponent from "@/components/board/BoardDetailComponent";
    import CommentListComponent from "@/components/board/comment/CommentListComponent";
    import CommentReplyModal from "@/components/modal/CommentReplyModal"
    export default {
        name: 'SsamsContentDetail',
        mixins: [],
        components: {BoardDetailComponent, CommentListComponent,CommentReplyModal},
        provide() {
            return {}
        },
        props: {},
        data() {
            return {
                boardKey: Number(this.$route.params.idx),
              ssamsKey: Number(this.$route.params.s_idx),
            }
        },
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
        },
        methods: {

        },
        watch: {},
    }
</script>
